import { types } from 'mobx-state-tree'
import '../../ieConfig/MobxConfig'

const Card = types.model('Card', {
  scheme: types.optional(types.string, ''),
  type: types.optional(types.string, ''),
  cardBin: types.optional(types.string, ''),
  product: types.optional(types.string, '*'),
  isDomestic: types.optional(types.string, '*'),
})
const ConvenienceFee = types.model('ConvenienceFee', {
  bankId: types.optional(types.string, ''),
  walletId: types.optional(types.string, ''),
  card: types.optional(Card, {}),
  cgst: types.optional(types.string, '0'),
  igst: types.optional(types.string, '0'),
  sgst: types.optional(types.string, '0'),
  tcs: types.optional(types.string, '0'),
  tds: types.optional(types.string, '0'),
  ugst: types.optional(types.string, '0'),
  totalFee: types.optional(types.string, ''),
})
export { ConvenienceFee }
